<template>
  <div class="screen-layout" id="screen-layout" :style="layoutStyle">
    <div class="screen-container" :style="containerStyle">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: "LayoutScreen",
  data() {
    return {
      // 设计稿基准尺寸
      baseWidth: 1920,
      baseHeight: 1080,
      // 缩放比例
      scale: 1,
      // 是否全屏
      isFullscreen: false,
    };
  },
  computed: {
    layoutStyle() {
      return {
        width: "100%",
        height: "100%",
        overflow: "hidden",
        position: "relative",
        background: "#000",
      };
    },
    containerStyle() {
      return {
        width: this.baseWidth + "px",
        height: this.baseHeight + "px",
        // transform: `scale(${this.scale})`,
        // transformOrigin: 'left top',
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: `translate(-50%, -50%) scale(${this.scale})`,
        // marginLeft: -this.baseWidth / 2 + 'px',
        // marginTop: -this.baseHeight / 2 + 'px'
      };
    },
  },
  mounted() {
    // document.documentElement.requestFullscreen();
    this.initScreenAdapter();
    window.addEventListener("resize", this.initScreenAdapter);
    // 监听全屏变化
    // document.addEventListener("fullscreenchange", this.fullscreenChange);

    // document.addEventListener(
    //   "keydown",
    //   (e) => {
    //     if (e.key === "F11") {
    //       console.log("12313", 12313);
    //       this.toggleFullScreen();
    //     }
    //   },
    //   false
    // );
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.initScreenAdapter);
    // document.removeEventListener("fullscreenchange", this.fullscreenChange);
  },
  methods: {
    // async toggleFullScreen() {
    //   console.log(
    //     "document.documentElement",
    //     document.documentElement,
    //     document.fullscreenElement
    //   );
    //   if (!document.fullscreenElement) {
    //     document.documentElement.requestFullscreen();
    //   } else if (document.exitFullscreen) {
    //     document.exitFullscreen();
    //   }
    // },
    initScreenAdapter() {
      const clientWidth = document.documentElement.clientWidth;
      const clientHeight = document.documentElement.clientHeight;
      // 计算缩放比例
      const widthScale = clientWidth / this.baseWidth;
      const heightScale = clientHeight / this.baseHeight;
      this.scale = Math.min(widthScale, heightScale);
    },
    // 切换全屏
    // async toggleFullScreen() {
    //   if (!this.isFullscreen) {
    //     await document.documentElement.requestFullscreen();
    //   } else {
    //     await document.exitFullscreen();
    //   }
    // },
    // 全屏变化事件
    // fullscreenChange() {
    //   this.isFullscreen = document.fullscreenElement !== null;
    //   this.initScreenAdapter();
    // },
  },
};
</script>

<style lang="scss" scoped>
.screen-layout {
  background-color: #000;
  color: #fff;
}

.screen-container {
  background-color: #000;
  user-select: none;
  //   transition: transform 0.3s;

  /** 禁用图片的拖拽 */
  img {
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    user-drag: none;
  }
}
</style>
